import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import * as Actions from '../../actions/actions';
import Storage from '../Helpers/Storage/Storage';

const PetCard = function (props) {
  const {
    image, name, to, species
  } = props;
  return (
    <Link to={to} key={name} alt={name}>
      {(image || Storage.has(species)) && <img src={image || Storage.get(species)} alt={name} />}
      <div className="name">{name}</div>
    </Link>
  );
};

export default connect(state => ({ ...state.petReducer }), dispatch => bindActionCreators(Actions, dispatch))(PetCard);



// WEBPACK FOOTER //
// ./src/pages/Pets/PetCard.js